import * as signalR from '@microsoft/signalr';
import i18n from '../modules/i18n/index';
import axios from '../utils/axiosHub'
import { getToken } from 'src/utils/Common';


let url = process.env.REACT_APP_BACKEND_URL;


const AuthToken = getToken();

const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${url}translationHub`, {
        accessTokenFactory: () => `${AuthToken}`
    })
    .withAutomaticReconnect()
    .build();

connection.start()
    .then(async () => {
        await connection.invoke('JoinGroup', 'CRM');
    })
    .catch(err => console.error(err.toString()));

connection.on(`ReceiveTranslationUpdate`, async (appName, language, translationEnv) => {

    const response = await axios.get(`/api/Translation/Get/${appName}/${language}/${translationEnv}`);



    const updatedTranslations = await response?.data;



    await i18n.addResourceBundle(language, translationEnv, updatedTranslations, true, true);
    console.log(i18n.getResourceBundle(language, translationEnv));

    if (i18n.language === language) {
        await i18n.changeLanguage(language);
    }
})

